<template>
  <a-layout :class="['layout', device]">
    <!-- SideMenu -->
    <a-drawer
      v-if="isMobile()"
      placement="left"
      :wrapClassName="`drawer-sider ${navTheme}`"
      :closable="false"
      :visible="collapsed"
      @close="drawerClose"
    >
      <side-menu
        mode="inline"
        :menus="mainMenu"
        :theme="navTheme"
        :collapsed="false"
        :collapsible="true"
        @menuSelect="menuSelect"
      ></side-menu>
    </a-drawer>

    <side-menu
      v-else-if="isSideMenu()"
      mode="inline"
      :menus="mainMenu"
      :theme="navTheme"
      :collapsed="collapsed"
      :collapsible="true"
    ></side-menu>

    <a-layout :class="[layoutMode, `content-width-${contentWidth}`]" :style="{ paddingLeft: contentPaddingLeft, minHeight: '100vh',overflow: 'visible',maxWidth:'100%' }">
      <!-- layout header -->
      <global-header
        :mode="layoutMode"
        :menus="mainMenu"
        :theme="navTheme"
        :collapsed="collapsed"
        :device="device"
        @toggle="toggle"
      />

      <!-- layout content -->
      <a-layout-content :style="{ height: '100%', margin: '20px 20px 0', paddingTop: fixedHeader ? '50px' : '0' }" style="position: relative">
          <span v-if="menuName" @click="showRules"  class="rules_class" :style="$route.fullPath == '/mine/work'?'right:375px':$route.fullPath == '/mine/news'?'right:340px':''">
             <pt-icon :title="$t('datapermission.modal.rulesTitle')"  type="icon-wenhao"></pt-icon>
          </span>


        <multi-tab v-if="multiTab" >

        </multi-tab>

        <transition name="page-transition" >
          <route-view />

        </transition>

      </a-layout-content>

      <!-- layout footer -->
      <a-layout-footer>
<!--        <global-footer />-->
      </a-layout-footer>

      <!-- Setting Drawer (show in development mode) -->
<!--      <setting-drawer v-if="!production"></setting-drawer>-->
    </a-layout>
    <div v-if="showUserCommissionAgreement && userCommissionAgreement.id">
      <userCommissonAgreementCard :user-commission-agreement="userCommissionAgreement" @close="getUserCommissionAgreements"></userCommissonAgreementCard>
    </div>
    <div class="otherModal_div" v-if="!showUserCommissionAgreement">
      <!-- 生日卡片 -->
      <birthday-card></birthday-card>
      <update-info></update-info>
      <update-passwrod></update-passwrod>
      <deal-be-over-due></deal-be-over-due>
      <leader-deal-confrim-be-over-due></leader-deal-confrim-be-over-due>
      <expiring-soon-deal-confrim-be-over-due></expiring-soon-deal-confrim-be-over-due>
      <deal-confrim-be-over-due></deal-confrim-be-over-due>
      <!-- 道远足迹 -->
      <news-pop-card></news-pop-card>
    </div>


    <a-modal class="ruleModal" :footer="null" v-model="visibleRule" :title="$t('datapermission.modal.rulesTitle')" on-ok="handleOk" width="800px" :maskClosable="false">
      <span slot="closeIcon" class="close-icon">
          <pt-icon type="icon-guanbi-copy"  :title="$t('baseVO.close')"></pt-icon>
      </span>
        <div v-html="this.rules">

        </div>
    </a-modal>



  </a-layout>

</template>

<script>
import { triggerWindowResizeEvent } from '@/utils/util'
import { mapState, mapActions } from 'vuex'
import { mixin, mixinDevice } from '@/utils/mixin'
import rulesApi from '@/api/sys/rules'
import config from '@/config/defaultSettings'
import updateInfo from '../components/tools/updateInfo'
import updatePasswrod from '../components/tools/password'
import DealBeOverDue from '../components/tools/DealBeOverDue'
import DealConfrimBeOverDue from '../components/tools/DealConfrimBeOverDue.vue'
// import ExpiringSoonDealConfrimBeOverDue from '../components/tools/ExpiringSoonDealConfrimBeOverDue.vue'
import LeaderDealConfrimBeOverDue from '@/components/tools/LeaderDealConfrimBeOverDue.vue'
import userCommissonAgreementCard from '../components/userCommissonAgreementCard/index.vue'
import RouteView from './RouteView'
import MultiTab from '@/components/MultiTab'
import SideMenu from '@/components/Menu/SideMenu'
import GlobalHeader from '@/components/GlobalHeader'
// import GlobalFooter from '@/components/GlobalFooter'
import SettingDrawer from '@/components/SettingDrawer'
import birthdayCard from '@/components/birthdayCard/index'
import newsPopCard from '@/components/newsPopCard/index.vue'
import {selectByLogin} from "@/api/manager/userCommissionAgreement";

export default {
  name: 'BasicLayout',
  mixins: [mixin, mixinDevice],
  components: {
    updateInfo,
    RouteView,
    MultiTab,
    birthdayCard,
    newsPopCard,
    SideMenu,
    GlobalHeader,
    // GlobalFooter,
    SettingDrawer,
    DealBeOverDue,
    updatePasswrod,
    DealConfrimBeOverDue,
    userCommissonAgreementCard,
    // ExpiringSoonDealConfrimBeOverDue,
    LeaderDealConfrimBeOverDue
  },
  data () {
    return {
      visibleRule:false,
      menuName:false,
      rules:undefined,
      production: config.production,
      collapsed: false,
      showUserCommissionAgreement:true,
      userCommissionAgreement:{},
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      mainMenu: state => state.permission.leftRouters
    }),
    contentPaddingLeft () {
      if (!this.fixSidebar || this.isMobile()) {
        return '0'
      }
      if (this.sidebarOpened) {
        return '180px'
      }
      return '80px'
    }
  },
  watch: {
    sidebarOpened (val) {
      this.collapsed = !val
    },
    $route(newValue){
      this.initRules(newValue.name)
    }
  },
  created () {
    this.collapsed = !this.sidebarOpened
  },
  mounted () {
    this.getUserCommissionAgreements()
    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed
        setTimeout(() => {
          this.collapsed = !this.collapsed
        }, 16)
      })
    }
  },
  methods: {
    getUserCommissionAgreements(){
      selectByLogin().then(res => {
        if(res.code == 1){
          if(res.data){
            this.userCommissionAgreement = res.data
            this.showUserCommissionAgreement = true;
          }else{
            this.userCommissionAgreement = {}
            this.showUserCommissionAgreement = false
            this.$forceUpdate();
          }
        }
      })
    },
    initRules(menuName){
      this.menuName =false
      rulesApi.selectOne(menuName).then(res => {
        if(res.code == 1){
          if(res.data != undefined ){
            this.menuName = true
            this.rules = res.data.rules
          }else{
            this.menuName = false
            this.rules = undefined
          }
        }
      })
    },
    showRules(){
      this.visibleRule = true
    },
    ...mapActions(['setSidebar']),
    toggle () {
      this.collapsed = !this.collapsed
      this.setSidebar(!this.collapsed)
      triggerWindowResizeEvent()
    },
    paddingCalc () {
      let left = ''
      if (this.sidebarOpened) {
        left = this.isDesktop() ? '256px' : '80px'
      } else {
        left = (this.isMobile() && '0') || ((this.fixSidebar && '80px') || '0')
      }
      return left
    },
    menuSelect () {
      if (!this.isDesktop()) {
        this.collapsed = false
      }
    },
    drawerClose () {
      this.collapsed = false
    }
  }
}
</script>
<style scoped lang="less">
.rules_class{
  position: absolute;top:51px;right: 4px ;z-index: 8;
}
</style>
<style lang="less">
@import url('../components/global.less');

/*
 * The following styles are auto-applied to elements with
 * transition="page-transition" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the page transition by editing
 * these styles.
 */

.page-transition-enter {
  opacity: 0;
}

.page-transition-leave-active {
  opacity: 0;
}

.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
